import { lazy } from 'react';
import { Route } from 'react-router-dom';

//场区到期推送提醒
const ExpiryReminder = lazy(() =>
  import(/* webpackChunkName: "ExpiryReminder" */ 'src/views/HMY/ExpiryReminder')
);
const HMYRouter = {
  '/HMY/ExpiryReminder': ExpiryReminder
};

export default function HMYRoute() {
  const keys = Object.keys(HMYRouter);
  const routeArr = keys.map(key => {
    const Components = HMYRouter[key];
    return <Route key={key} path={key} element={<Components />} />;
  });
  return routeArr;
}
